import * as types from './types';
import { resolve } from '../../middleware/simple-promise';

const initialState = {
  labData: null,
  catalogs: [],
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case resolve(types.LOAD_LAB):
      return {
        ...state,
        labData: payload
      };
    case resolve(types.LOAD_CATALOG):
      return {
        ...state,
        catalogs: payload
      };
    default:
      return state;
  }
};
